import styled from "@emotion/styled";

import Button from "components/ui/button/Button";
import { MOBILE_NAV_PANEL_ID, useSidebar } from "components/ui/sidebar/Sidebar";
import { routes } from "lib/routes";

import StotlesLogoText from "../../../../assets/images/stotles_logo_and_typeface.svg";

// The mobile top bar's height. Lives here (its only consumer) rather than as a CSS variable on the
// shared Sidebar primitive.
const TOP_NAV_HEIGHT_PX = 64;

const MobileTopNav = () => {
  const { openMobile, toggleSidebar } = useSidebar();

  return (
    <Bar>
      {/* eslint-disable-next-line no-restricted-syntax -- logo click intentionally does a full reload to reset mobile nav state, matching HorizontalNav's logo link */}
      <LogoWrapper href={routes.home}>
        <Logo src={StotlesLogoText} alt="Stotles Logo" />
      </LogoWrapper>
      <MenuButton
        buttonStyle="inverse"
        buttonType="primary"
        icon={openMobile ? "xClose" : "menu01"}
        iconProps={{ color: "sysTextSecondary" }}
        onClick={toggleSidebar}
        aria-label={openMobile ? "Close menu" : "Open menu"}
        aria-expanded={openMobile}
        aria-controls={MOBILE_NAV_PANEL_ID}
      />
    </Bar>
  );
};

const Bar = styled.header(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  flexShrink: 0, // never squashed by the nav panel that follows it in the column
  height: TOP_NAV_HEIGHT_PX,
  boxSizing: "border-box", // keep the border inside the height so the panel butts right up to it
  // Asymmetric per the design: 20 to the logo, 16 to the menu button's box.
  padding: "0 16px 0 20px",
  borderBottom: `1px solid ${theme.colors.sysBorderDecorative}`,
  backgroundColor: theme.colors.sysBackgroundDefault,
}));

// Same button variant as the sidebar nav items, so hover/press backgrounds match.
// The icon sits at secondary at rest and darkens to default text on hover/press.
const MenuButton = styled(Button)(({ theme }) => ({
  "&:hover .icon, &:active .icon, &.active .icon": {
    color: theme.colors.sysTextDefault,
  },
}));

const LogoWrapper = styled.a({
  display: "flex",
});

const Logo = styled.img({
  height: 24,
});

export default MobileTopNav;
